import { observer } from "mobx-react-lite";
import React, { useContext, useEffect } from "react";
import { Route, RouteComponentProps, Switch } from "react-router-dom";
import { RootStoreContext } from "../app/stores/rootStore";
import GenericModal from "../components/common/GenericModal";
import Loader from "../components/common/Loader";
import DisconnectedModal from "../components/widgets/DisconnectedModal";
import SyncScreen from "../components/widgets/SyncScreen";
import PodiumLayout from "./PodiumLayout";
import TenantDashboardLayout from "./TenantDashboardLayout";
import NearToLogoutForm from "../components/forms/NearToLogoutForm";

interface TenantParams {
  tenant: string;
}

const TenantLayout: React.FC<RouteComponentProps<TenantParams>> = ({
  match,
  history,
}) => {
  const rootStore = useContext(RootStoreContext);
  const {
    tenantLayoutLoaded,
    setTenantLayoutLoaded,
    theme,
    isAutoSyncEnabled,
  } = rootStore.commonStore;
  const { currentTenant, loadTenants, signInByPath, disconnectedModalOpen } =
    rootStore.tenantStore;
    const { logout, inactivityModalClose, nearToLogout } = rootStore.userStore;
  const { isSynced } = rootStore.playerStore;

  useEffect(() => {
    if (!currentTenant) {
      loadTenants()
        .then(() => {
          if (match.params.tenant) {
            signInByPath(match.params.tenant).then((dto) =>
           {   
             setTenantLayoutLoaded();

           });
          } else {
            history.push("/home");
          }
        })
        .catch((error) => {
          setTenantLayoutLoaded();
        });
      }
  }, [
    loadTenants,
    signInByPath,
    setTenantLayoutLoaded,
    currentTenant,
    history,
    match.params.tenant,
    theme,
  ]);

  if (!tenantLayoutLoaded) return <Loader />;

  return (
    <>
     {nearToLogout && (<div className="overlay" onClick={() => inactivityModalClose(true)}></div>)}
    <GenericModal
      toggle={() => inactivityModalClose(true)}
    title={'Attenzione'}
    isOpen={nearToLogout}
    content={
        <NearToLogoutForm
        isOpen={nearToLogout}
        toggleClose={inactivityModalClose}
        logout={logout} 
        />}
      />
      <Switch>
      <Route
          path="/:tenant/meeting/:meetingId/podium/preview/:accept"
          component={PodiumLayout}
        />
        <Route
          path="/:tenant/meeting/:meetingId/podium"
          component={PodiumLayout}
        />
        
        <Route component={TenantDashboardLayout} />
      </Switch>
      {(isSynced || isAutoSyncEnabled) && <SyncScreen />}
      <GenericModal
        isOpen={disconnectedModalOpen}
        toggle={() => {}}
        content={<DisconnectedModal />}
        size="md"
      />
    </>
  );
};

export default observer(TenantLayout);
